module.exports = __webpack_public_path__ + "static/media/no-record.5014e0bf.png";